<template>
  <div class="panel">
    <div class="title">
      应用中心配置
      <router-link
        class="option-name"
        target="_blank"
        :to="{ path: '/application-config/nameList' }"
        >配置选项名称</router-link
      >
    </div>
    <div class="template-list">
      <TemplateCard />
      <TemplateCard
        v-for="item in templateList"
        :key="item.uid"
        :name="item.name"
        :remark="item.remark"
        :bgImg="item.iconUrl"
        :orderIndex="item.orderIndex"
        @deleteTemplate="deleteTemplate"
        @offShelvesShop="offShelvesShop"
        @onShelvesShop="onShelvesShop"
        :status="item.status"
        :enable="item.enable"
        :id="item.uid"
      />
    </div>
  </div>
</template>

<script>
import TemplateCard from './components/TemplateCard'
import { getTemplateDto, changeApplyhub } from '../../API/application'
export default {
  components: {
    TemplateCard
  },
  created () {
    this.getTemplateDto()
  },
  data () {
    return {
      templateList: [
      ]
    }
  },
  methods: {
    async getTemplateDto () {
      const data = await getTemplateDto({ sort: 0 })
      console.log('dataaaaa', data)
      this.templateList = data
    },
    async deleteTemplate (uid) {
      const res = await changeApplyhub({ uid: uid, status: -1 })
      console.log('res-del', res)
      if (res === '成功') {
        this.$message({
          type: 'success',
          message: '删除成功!'
        })
      } else {
        this.$message({
          type: 'error',
          message: res
        })
      }
      this.getTemplateDto()
    },
    // 上架
    async onShelvesShop (uid) {
      const res = await changeApplyhub({ uid: uid, status: 1 })
      console.log('res', res)
      this.getTemplateDto()
      this.$message({
        type: 'success',
        message: '上架成功'
      })
    },
    // 下架
    async offShelvesShop (uid, status) {
      const res = await changeApplyhub({ uid: uid, status: 0 })
      console.log('res', res)
      this.getTemplateDto()
      this.$message({
        type: 'success',
        message: '下架成功'
      })
      if (status === 'toEdit') {
        this.$router.push({
          path: `/application-config/edit/${uid || null}`
        })
      }
    },
    goOption () {
      this.$router.push('/application-config/nameList')
    }

  }
}
</script>

<style lang="less" scoped>
.panel {
  .title {
    font-size: 20px;
    color: var(--main-text);
    margin-bottom: 32px;
  }
  .template-list {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
  }
  .option-name {
    color: #2878ff;
    font-size: 14px;
    cursor: pointer;
    text-decoration: none;
  }
}
</style>
